import React, { useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import {
  Grid,
  Typography,
  Dialog,
  Tooltip,
  Fab,
  TextField,
  FormControl,
  FormHelperText,
  Box,
} from '@mui/material';
import Button from '@mui/material/Button';
import {
  getUserData,
  getUserLeaves,
  getUserPhoto,
  getUserProjects,
  updateUserPhoto,
} from '../../services/UserService';
import { getAllEmployeesOffBoarded } from '../../services/EmployeeService';
import { getApprovedSkills } from '../../tech-council/Services/SkillsService';
import KeycloakService from '../../services/KeycloakService';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import IconButton from '@mui/material/IconButton';
import moment from 'moment';
import Chip from '@mui/material/Chip';
import Avatar from '@mui/material/Avatar';
import Rating from '@mui/material/Rating';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import {
  updateEmployee,
  nextAvailableEmployeeCode,
  checkForEmployeeId,
} from '../../services/EmployeeService';

import {
  getDesignations,
  updateEmployeeRole,
} from '../../admin/Services/MasterdataService';

import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { ERROR_KEY, SHOW_NOTIFICATION } from '../../constants';
import './ProfileComponent.css';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { leaveType } from '../Leaves/LeavesConstants';
import AddSkill from './AddSkill';
import Notes from '../../components/Notes/Notes';
import '../../components/Notes/Notes.css';
import imageCompression from 'browser-image-compression';
import { LoadingButton } from '@mui/lab';
import { ADMIN_PATH, MINIO_PATH } from '../../url';
import { getUserManagers } from '../../services/UserService';
import HttpService from '../../services/HttpService';

const UserProfile = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const people = useSelector((state) => state.peopleState);
  const leaveTab = useSelector((state) => state.leaveTabState);
  const currentUserId = () => KeycloakService.getUserDetail();
  const [userDetails, setUserDetails] = useState({});
  const [userProjects, setUserProjects] = useState([]);
  const [userLeave, setUserLeave] = useState(null);
  const [loader, setLoader] = useState(true);
  const [open, setOpen] = useState(false);
  const [approvedSkills, setApprovedSkills] = useState([]);
  const [editing, setEditing] = useState(false);
  const [editingIndex, setEditingIndex] = useState();
  const tenantId = process.env.REACT_APP_TENANT_ID;
  const [pageSize, setPageSize] = useState(5);
  const [pageNo, setPageNo] = useState(0);
  const [userOffboardedEndDate, setUserOffboardedEndDate] = useState({});
  const [photoUrl, setPhotoUrl] = useState('');
  const [uploadedPhoto, setUploadedPhoto] = useState();
  const [files, setFiles] = useState();
  const [showErrorMessage, setShowErrorMessage] = useState(false);

  const [designationNames, setDesignationNames] = useState([]);
  const [isEditable, setIsEditable] = React.useState(false);
  const [updatedEmployeeDetails, setUpdatedEmployeeDetails] = React.useState(
    {},
  );
  const [isDateValidDoj, setIsDateValidDoj] = useState(true);
  const [isDateValidDoi, setIsDateValidDoi] = useState(true);
  const [showErrorMessageDoj, setShowErrorMessageDoj] = useState(false);
  const [showErrorMessageDoi, setShowErrorMessageDoi] = useState(false);
  const [dojError, setDojError] = React.useState(null);
  const [doiError, setDoiError] = React.useState(null);
  const [isValidEmployeeCode, setIsValidEmployeeCode] = useState(true);
  const [showErrorMessageEmployeeCode, setShowErrorMessageEmployeeCode] =
    useState(false);
  const [newJobType, setNewJobType] = useState('');
  const [managerList, setManagerList] = useState();

  const [isLoggedInUserManager, setIsLoggedInUserManager] = useState(false);
  const [officeLocation, setOfficeLocation] = useState([]);
  const [leaveGroups, setLeaveGroups] = useState([]);

  const _axios = HttpService.getAxiosClient();

  const fetchOfficeLocation = async () => {
    setOfficeLocation([]);
    try {
      const response = await _axios.get(`${ADMIN_PATH}/office-location`);
      if (response.status === 200) setOfficeLocation(response?.data?.data);
    } catch (error) {
      console.error('Error fetching office location:', error);
    }
  };

  const fetchLeaveGroups = async () => {
    setLeaveGroups([]);
    try {
      const response = await _axios.get(`${ADMIN_PATH}/leave-group`);
      if (response.status === 200) setLeaveGroups(response?.data?.data || []);
    } catch (error) {
      console.error('Error fetching leave groups:', error);
    }
  };

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const handleRateYourself = () => {
    setEditing(false); // Assuming searchString is defined somewhere
    setOpen(true);
  };

  const handleEdit = (index) => {
    if (
      isDateDifferenceGreaterThanSixMonths(approvedSkills[index].approvalDate)
    ) {
      setEditing(true);
      setEditingIndex(index);
      setOpen(true);
    } else {
      dipatchNotification(
        'error',
        'This option will be active during the upcoming appraisal cycle',
      );
    }
  };

  useEffect(() => {
    fetchOfficeLocation();
    fetchLeaveGroups();
  }, []);

  useEffect(() => {
    if (dojError != null) setShowErrorMessageDoj(true);
    else setShowErrorMessageDoj(false);
  }, [dojError]);

  useEffect(() => {
    if (!updatedEmployeeDetails.employeeCode) {
      setUpdatedEmployeeDetails({
        ...updatedEmployeeDetails,
        employeeCode: userDetails.employeeCode,
      });
    }

    if (updatedEmployeeDetails.jobType && isEditable) {
      fetchEmployeeCode(updatedEmployeeDetails.jobType);
    }
  }, [isEditable, newJobType]);

  useEffect(() => {
    loadData();
  }, [people]);

  useEffect(() => {
    getAllDesignation();
  }, []);

  useEffect(() => {
    setUpdatedEmployeeDetails({ ...userDetails });
    setNewJobType(userDetails.jobType);
  }, [userDetails]);

  useEffect(() => {
    const fetchManagerList = async () => {
      try {
        const employeeId = userDetails.id;
        const managerList1 = await getUserManagers(employeeId);
        const managers = managerList1.data;
        setManagerList(managers);

        const loggedInUser = KeycloakService.getUserEmail();
        console.log(loggedInUser, 'loggedInUser');
        const isManager = managers.some(
          (manager) => manager.emailId === loggedInUser,
        );
        setIsLoggedInUserManager(isManager);
      } catch (e) {
        console.error(
          'Error fetching manager list or checking logged-in user:',
          e,
        );
      }
    };

    fetchManagerList();
  }, [userDetails]);

  const onJoiningDatePickerInputChange = (e) => {
    const { dateOfJoining, ...newemployeeDetails } = updatedEmployeeDetails;
    console.log('e', e);

    setUpdatedEmployeeDetails({
      ...newemployeeDetails,
      dateOfJoining: e,
    });
  };

  const onInternshipDatePickerInputChange = (e) => {
    const { dateOfInternship, ...newemployeeDetails } = updatedEmployeeDetails;
    console.log('e', e);

    setUpdatedEmployeeDetails({
      ...newemployeeDetails,
      dateOfInternship: e,
    });
  };

  const handleEdit1 = () => {
    setIsEditable(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleEditClose = () => {
    setIsEditable(false);
    setUpdatedEmployeeDetails({ ...userDetails });
    setNewJobType(userDetails.jobType);
    setIsDateValidDoj(true);
    setDojError(null);
    setShowErrorMessageEmployeeCode(false);
    setIsValidEmployeeCode(true);
    setShowErrorMessageDoj(false);
  };

  const handleSave = async () => {
    // Intern → non-Intern requires Internship End Date (backend also enforces).
    if (
      userDetails?.jobType === 'INTERNSHIP' &&
      updatedEmployeeDetails?.jobType &&
      updatedEmployeeDetails.jobType !== 'INTERNSHIP' &&
      !updatedEmployeeDetails?.internshipEndDate
    ) {
      dipatchNotification(
        'error',
        'Internship End Date is required when transitioning from Internship.',
      );
      return;
    }
    // Explicit clear vs assign: selecting "No group selected" clears when a group was assigned.
    // Partial updates that never touch Leave Group still omit (do not wipe) via clearLeaveGroup=false.
    const clearedLeaveGroup =
      updatedEmployeeDetails?.leaveGroupId == null &&
      userDetails?.leaveGroupId != null;
    const payload = {
      ...updatedEmployeeDetails,
      leaveGroupId: clearedLeaveGroup
        ? null
        : updatedEmployeeDetails?.leaveGroupId != null
          ? updatedEmployeeDetails.leaveGroupId
          : userDetails?.leaveGroupId,
      clearLeaveGroup: clearedLeaveGroup,
    };
    let response = await updateEmployee(payload);
    if (response.isError === false) {
      setIsEditable(false);
      const saved = {
        ...payload,
        leaveGroupId: payload.clearLeaveGroup ? null : payload.leaveGroupId,
      };
      setUserDetails(saved);
      setUpdatedEmployeeDetails(saved);
    }
    if (response.status !== 200) {
      dipatchNotification(response.type, response.message);
    }

    if (response.isError === false) {
      let responseUpdateRole;
      responseUpdateRole = await updateEmployeeRole(payload);
      if (responseUpdateRole.status !== 200) {
        dipatchNotification(
          responseUpdateRole.type,
          responseUpdateRole.message,
        );
      }
      if (responseUpdateRole.status === 200) {
        dipatchNotification(
          responseUpdateRole.type,
          responseUpdateRole.message,
        );
      }
    }
    setIsEditable(false);
    setNewJobType(userDetails.jobType);
    setIsDateValidDoj(true);
    setDojError(null);
    setShowErrorMessageEmployeeCode(false);
    setIsValidEmployeeCode(true);
    setShowErrorMessageDoj(false);
  };

  const fetchEmployeeCode = async (jobType) => {
    const code = await nextAvailableEmployeeCode(jobType);

    if (jobType === userDetails.jobType) {
      setUpdatedEmployeeDetails({
        ...updatedEmployeeDetails,
        employeeCode: userDetails.employeeCode,
      });
      return;
    }

    setUpdatedEmployeeDetails((prevDetails) => ({
      ...prevDetails,
      employeeCode: code?.data?.data,
    }));
  };

  const handleEmployeeCodeChange = async (event) => {
    const value = event.target.value;
    const regex = /^[1-9]+[0-9]*$/; // regular expression to make sure it is a non zero number.
    const regex1 = /[\D]+/; // regular expression to check if there is any non digit character.

    if (regex1.test(value)) return;

    if (!regex.test(value)) {
      setShowErrorMessageEmployeeCode(false);
      setIsValidEmployeeCode(false);
      setUpdatedEmployeeDetails((prevDetails) => ({
        ...prevDetails,
        employeeCode: value,
      }));
      return;
    } else {
      setIsValidEmployeeCode(true);
      setUpdatedEmployeeDetails((prevDetails) => ({
        ...prevDetails,
        employeeCode: value,
      }));
    }

    try {
      const checkingEmployeeCode = await checkForEmployeeId(value, tenantId);

      if (checkingEmployeeCode?.data?.data === true) {
        setShowErrorMessageEmployeeCode(true);
      } else {
        setShowErrorMessageEmployeeCode(false);
      }

      setUpdatedEmployeeDetails((prevDetails) => ({
        ...prevDetails,
        employeeCode: value,
      }));
    } catch (error) {
      console.log('error', error);
    }
  };

  const handleDesignationChange = async (event) => {
    const designation = event.target.value;
    setUpdatedEmployeeDetails((prevDetails) => ({
      ...prevDetails,
      designation: designation,
    }));
  };

  const handleLocationChange = async (event) => {
    const locationId = event?.target?.value;
    const selectedLocation = officeLocation.find(
      (loc) => loc.id === locationId,
    );
    setUpdatedEmployeeDetails((prevDetails) => ({
      ...prevDetails,
      locationId: locationId,
      locationName: selectedLocation?.locationName,
    }));
  };

  const handleLeaveGroupChange = (event) => {
    const value = event.target.value === '' ? null : event.target.value;
    setUpdatedEmployeeDetails((prevDetails) => ({
      ...prevDetails,
      leaveGroupId: value,
    }));
  };

  const handleJobTypeChange = async (event) => {
    const jobType = event.target.value;
    setUpdatedEmployeeDetails((prevDetails) => ({
      ...prevDetails,
      jobType: jobType,
    }));
    setIsValidEmployeeCode(true);
    setShowErrorMessageEmployeeCode(false);
    setNewJobType(jobType);
  };

  let designationData;

  const getAllDesignation = async () => {
    designationData = await getDesignations(process.env.REACT_APP_TENANT_ID);

    const newDesignationNames = designationData.data.data.map(
      (data) => data.designationNames[0],
    );
    setDesignationNames(newDesignationNames);
  };

  const loadData = async () => {
    let user;
    if (people.id === '' && currentUserId !== undefined) {
      user = await getUserData(currentUserId());
    } else {
      user = await getUserData(people.id);
    }

    if (user.isError === false) {
      setUserDetails(user.data);
      const projects = await getUserProjects(
        user.data.id,
        '',
        '',
        '',
        'ACTIVE',
      );
      if (projects.isError === false) {
        setUserProjects(projects.data.content);
      }
      const leaves = await getUserLeaves(user.data.id, '');
      if (leaves.isError === false) {
        getUpcomingLeave(leaves.data.data.content);
      } else {
        setUserLeave(null);
      }

      const offboardedEmployee = await getAllEmployeesOffBoarded(
        tenantId,
        '',
        '',
        '',
        '',
        user.data.emailId,
      );

      if (offboardedEmployee.isError === false) {
        const employee = offboardedEmployee.data.data.content;

        // Find the offboarded employee with the user's ID
        const userOffboardedEmployee = employee.find(
          (item) => item.employeeId === user.data.id,
        );

        if (userOffboardedEmployee) {
          setUserOffboardedEndDate(userOffboardedEmployee);
        } else {
          setUserOffboardedEndDate({});
        }
      }
      setLoader(false);
    }
    if (user.status !== 200) {
      dipatchNotification(user.type, user.message);
    }
    const response = await getApprovedSkills(user.data.id);
    setApprovedSkills(response.data?.data.content);
  };

  const onChange = async (event, value, id) => {
    const regex = /^(|^[A-Za-z\s]+)$/; // Regular expression to allow only alphabetic characters and spaces
    if (id === 'firstName') {
      if (!regex.test(value)) {
        // Value contains numbers, do not update state
        return;
      }
      const { firstName, ...newemployeeDetails } = updatedEmployeeDetails;
      setUpdatedEmployeeDetails({
        ...newemployeeDetails,
        firstName: value,
      });
    } else if (id === 'lastName') {
      if (!regex.test(value)) {
        // Value contains numbers, do not update state
        return;
      }
      const { lastName, ...newemployeeDetails } = updatedEmployeeDetails;
      setUpdatedEmployeeDetails({
        ...newemployeeDetails,
        lastName: value,
      });
    }
  };

  const handleNameBlur = (event, value, id) => {
    if (id === 'firstName') {
      const { firstName, ...newemployeeDetails } = updatedEmployeeDetails;
      setUpdatedEmployeeDetails({
        ...newemployeeDetails,
        firstName: value.trim(),
      });
    } else if (id === 'lastName') {
      const { lastName, ...newemployeeDetails } = updatedEmployeeDetails;
      setUpdatedEmployeeDetails({
        ...newemployeeDetails,
        lastName: value.trim(),
      });
    }
  };

  const errorMessage2 = React.useMemo(() => {
    switch (dojError) {
      case 'invalidDate': {
        setIsDateValidDoj(false);
        return 'Invalid date';
      }
      default: {
        if (!updatedEmployeeDetails.dateOfJoining) {
          setIsDateValidDoj(false);
          return 'Date of joining is required'; // Set the error message for empty dateOfJoining
        } else {
          setIsDateValidDoj(true);
          return '';
        }
      }
    }
  }, [dojError, updatedEmployeeDetails.dateOfJoining]);

  const getUpcomingLeave = (leaveArray) => {
    const currentDate = new Date(new Date().setHours(0, 0, 0, 0));
    let leave = leaveArray.filter(function (item) {
      return (
        (new Date(item.startDate) - currentDate >= 0 ||
          new Date(item.endDate) - currentDate >= 0) &&
        item.status === 'APPROVED' &&
        item.type !== 'WFH'
      );
    });
    leave.sort((obj1, obj2) =>
      obj1.startDate > obj2.startDate
        ? 1
        : obj1.startDate < obj2.startDate
          ? -1
          : 0,
    );
    setUserLeave(leave[0]);
  };

  const isDateDifferenceGreaterThanSixMonths = (approvedDate) => {
    const approved = new Date(approvedDate);
    const today = new Date();
    approved.setMonth(approved.getMonth() + 6);
    return today > approved;
  };

  const getPhotoUrl = async (photoPath) => {
    const response = await getUserPhoto(photoPath);
    if (response.status === 200) {
      const url = new URL(response.data);
      const remainingUrl = url.pathname + url.search;
      setPhotoUrl(`${MINIO_PATH}${remainingUrl}`);
      console.log(`${MINIO_PATH}${remainingUrl}`, 'miniostring');
    }
  };

  const handlePhotoUpload = async (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    if (file && file.type === 'image/png' && file.size <= 1024 * 1024) {
      reader.onload = (e) => {
        setUploadedPhoto(e.target.result);
      };

      reader.readAsDataURL(file);
      const options = {
        quality: 0.8,
      };
      try {
        const compressedFile = await imageCompression(file, options);
        setFiles(compressedFile);
      } catch (error) {
        console.log(error);
      }

      setShowErrorMessage(false);
    } else {
      setShowErrorMessage(true);
      setFiles(null);
    }
  };

  const onCancel = () => {
    setUploadedPhoto();
  };

  const onSave = async () => {
    const response = await updateUserPhoto(userDetails, files);
    if (response.status === 200) {
      setUploadedPhoto();
      // getPhotoUrl();
      loadData();
    }
  };

  useEffect(() => {
    if (userDetails?.photoPath) getPhotoUrl(userDetails.photoPath);
  }, [userDetails]);

  return (
    <Card elevation={0} sx={{ marginTop: '1rem' }}>
      <Grid
        sx={{
          marginTop: '0.4rem',
          textAlign: 'right',
          position: 'relative',
          display: 'block',
        }}
        container
        columns={{ xs: 12 }}
        rowSpacing={2}
        columnSpacing={0}
      >
        {KeycloakService.hasRole(['hr']) &&
          location.pathname !== '/user-profile' &&
          (!isEditable ? (
            <>
              <Tooltip
                title={
                  <Typography sx={{ fontSize: '0.8rem' }}>
                    Edit Details
                  </Typography>
                }
                placement="top"
                sx={{ position: 'absolute' }}
              >
                <Fab
                  color="secondary"
                  size="small"
                  style={{
                    position: 'relative',
                    top: '10px',
                    right: '100px',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    handleEdit1();
                  }}
                >
                  <EditIcon />
                </Fab>
              </Tooltip>
            </>
          ) : (
            <>
              <Tooltip
                title={
                  <Typography sx={{ fontSize: '0.8rem' }}>Cancel </Typography>
                }
                placement="top"
                sx={{ position: 'absolute' }}
              >
                <Fab
                  color="secondary"
                  size="small"
                  style={{
                    position: 'relative',
                    top: '10px',
                    right: '100px',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    handleEditClose();
                  }}
                >
                  <CloseIcon />
                </Fab>
              </Tooltip>
              <Tooltip
                title={
                  <Typography sx={{ fontSize: '0.8rem' }}>
                    Save Details
                  </Typography>
                }
                placement="top"
                sx={{ position: 'absolute' }}
              >
                <Fab
                  color="secondary"
                  size="small"
                  type="submit"
                  style={{
                    position: 'absolute',
                    top: '10px',
                    right: '30px',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    handleSave();
                  }}
                  disabled={
                    !isValidEmployeeCode ||
                    showErrorMessageEmployeeCode ||
                    // showErrorMessageDoj ||
                    !isDateValidDoj ||
                    !updatedEmployeeDetails?.firstName ||
                    !updatedEmployeeDetails?.lastName
                  }
                >
                  <SaveIcon />
                </Fab>
              </Tooltip>
            </>
          ))}
        {(KeycloakService.hasRole(['manager']) ||
          KeycloakService.hasRole(['hr']) ||
          KeycloakService.hasRole(['admin'])) &&
          !isEditable && (
            <Box className="styleForProfileComponentNote">
              <Notes employee={userDetails} />
            </Box>
          )}
      </Grid>
      {isEditable &&
        KeycloakService.hasRole(['hr']) &&
        location.pathname !== '/user-profile' && (
          <FormControl>
            <form
              sx={{ padding: '1rem', width: '100%' }}
              onSubmit={(event) => {
                event.preventDefault();
                handleSave();
              }}
            >
              <Grid
                sx={{
                  margin: '2rem',
                }}
                container
                // columns={{ xs: 12 }}
                rowSpacing={3}
                columnSpacing={2}
              >
                <Grid
                  sx={{ margin: '1rem', width: '90%' }}
                  container
                  columns={{ xs: 12 }}
                  rowSpacing={3}
                  columnSpacing={2}
                >
                  <Grid item md={6} sm={12}>
                    <FormControl sx={{ width: '15rem' }}>
                      <TextField
                        required
                        id="firstName"
                        label="First Name"
                        error={!updatedEmployeeDetails?.firstName}
                        helperText={
                          updatedEmployeeDetails?.firstName
                            ? ''
                            : 'Cannot be empty'
                        }
                        value={updatedEmployeeDetails?.firstName || ''}
                        onChange={(e) =>
                          onChange(e, e.target.value, e.target.id)
                        }
                        onBlur={(e) =>
                          handleNameBlur(e, e.target.value, e.target.id)
                        }
                        className="onFocusBorder"
                      />
                    </FormControl>
                  </Grid>

                  <Grid item md={6} sm={12}>
                    <FormControl sx={{ width: '15rem' }}>
                      <TextField
                        required
                        id="lastName"
                        label="Last Name"
                        error={!updatedEmployeeDetails?.lastName}
                        helperText={
                          updatedEmployeeDetails?.lastName
                            ? ''
                            : 'Cannot be empty'
                        }
                        value={updatedEmployeeDetails?.lastName || ''}
                        onChange={(e) =>
                          onChange(e, e.target.value, e.target.id)
                        }
                        onBlur={(e) =>
                          handleNameBlur(e, e.target.value, e.target.id)
                        }
                        className="onFocusBorder"
                      />
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid
                  sx={{ margin: '1rem', width: '90%' }}
                  container
                  columns={{ xs: 12 }}
                  rowSpacing={3}
                  columnSpacing={2}
                >
                  <Grid item md={6} sm={12}>
                    <FormControl sx={{ width: '15rem' }} required>
                      <TextField
                        required
                        id="id"
                        label="Employee Code"
                        value={updatedEmployeeDetails?.employeeCode || ''}
                        onChange={(e) => handleEmployeeCodeChange(e)}
                        className="onFocusBorder"
                        error={
                          showErrorMessageEmployeeCode || !isValidEmployeeCode
                        }
                        helperText={
                          showErrorMessageEmployeeCode
                            ? 'This Employee Code is not available!'
                            : isValidEmployeeCode
                              ? 'This Employee Code is available'
                              : 'Invalid Employee Code!'
                        }
                      />
                    </FormControl>
                  </Grid>

                  <Grid item md={6} sm={12}>
                    <FormControl required sx={{ width: '15rem' }}>
                      <InputLabel
                        htmlFor="job-type-select"
                        style={{ background: '#fff' }}
                      >
                        Job Type
                      </InputLabel>
                      <Select
                        labelId="job-type-select"
                        id="job-type-select"
                        value={updatedEmployeeDetails?.jobType}
                        onChange={handleJobTypeChange}
                        displayEmpty
                      >
                        <MenuItem value="FULL_TIME">FULL_TIME</MenuItem>
                        <MenuItem value="PART_TIME">PART_TIME</MenuItem>
                        <MenuItem value="INTERNSHIP">INTERNSHIP</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid
                  sx={{ margin: '1rem', width: '90%' }}
                  container
                  columns={{ xs: 12 }}
                  rowSpacing={3}
                  columnSpacing={2}
                >
                  {updatedEmployeeDetails?.jobType === 'INTERNSHIP' ? (
                    <Grid item md={4} sm={12}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Tooltip
                          open={
                            showErrorMessageDoi &&
                            !updatedEmployeeDetails?.dateOfInternship
                          }
                          title="Please select a date of internship."
                          classes={{
                            tooltip: 'custom-tooltip1',
                            arrow: 'custom-tooltip-arrow1',
                          }}
                          placement="bottom"
                        >
                          <FormControl required sx={{ width: '15rem' }}>
                            <DatePicker
                              label="Date of Internship*"
                              id="doi"
                              value={
                                updatedEmployeeDetails?.dateOfInternship || null
                              }
                              onChange={(newValue) => {
                                // Update the state with the selected internship date
                                setUpdatedEmployeeDetails((prevDetails) => ({
                                  ...prevDetails,
                                  dateOfInternship: newValue,
                                }));
                              }}
                              onError={(newError) => {
                                setDoiError(newError);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  error={!isDateValidDoi}
                                  helperText={errorMessage2}
                                />
                              )}
                            />
                          </FormControl>
                        </Tooltip>
                      </LocalizationProvider>
                    </Grid>
                  ) : (
                    <Grid item md={4} sm={12}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Tooltip
                          open={
                            showErrorMessageDoj &&
                            !updatedEmployeeDetails?.dateOfJoining
                          }
                          title="Please select a date of joining."
                          classes={{
                            tooltip: 'custom-tooltip1',
                            arrow: 'custom-tooltip-arrow1',
                          }}
                          placement="bottom"
                        >
                          <FormControl required sx={{ width: '15rem' }}>
                            <DatePicker
                              label="Date of Joining*"
                              id="doj"
                              value={
                                updatedEmployeeDetails?.dateOfJoining || null
                              }
                              onChange={(newValue) => {
                                // Update the state with the selected joining date
                                setUpdatedEmployeeDetails((prevDetails) => ({
                                  ...prevDetails,
                                  dateOfJoining: newValue,
                                }));
                              }}
                              onError={(newError) => {
                                setDojError(newError);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  error={!isDateValidDoj}
                                  helperText={errorMessage2}
                                />
                              )}
                            />
                          </FormControl>
                        </Tooltip>
                      </LocalizationProvider>
                    </Grid>
                  )}

                  {updatedEmployeeDetails?.jobType !== 'INTERNSHIP' && (
                    <Grid item md={4} sm={12}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <FormControl sx={{ width: '15rem' }}>
                          <DatePicker
                            label="Career Start Date"
                            id="careerStartDate"
                            value={
                              updatedEmployeeDetails?.careerStartDate || null
                            }
                            onChange={(newValue) => {
                              setUpdatedEmployeeDetails((prevDetails) => ({
                                ...prevDetails,
                                careerStartDate: newValue,
                              }));
                            }}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </FormControl>
                      </LocalizationProvider>
                    </Grid>
                  )}

                  {(updatedEmployeeDetails?.jobType === 'INTERNSHIP' ||
                    userDetails?.jobType === 'INTERNSHIP' ||
                    updatedEmployeeDetails?.internshipEndDate) && (
                    <Grid item md={4} sm={12}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <FormControl
                          required={
                            userDetails?.jobType === 'INTERNSHIP' &&
                            updatedEmployeeDetails?.jobType !== 'INTERNSHIP'
                          }
                          sx={{ width: '15rem' }}
                        >
                          <DatePicker
                            label={
                              userDetails?.jobType === 'INTERNSHIP' &&
                              updatedEmployeeDetails?.jobType !== 'INTERNSHIP'
                                ? 'Internship End Date*'
                                : 'Internship End Date'
                            }
                            id="internshipEndDate"
                            value={
                              updatedEmployeeDetails?.internshipEndDate || null
                            }
                            onChange={(newValue) => {
                              setUpdatedEmployeeDetails((prevDetails) => ({
                                ...prevDetails,
                                internshipEndDate: newValue,
                              }));
                            }}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </FormControl>
                      </LocalizationProvider>
                    </Grid>
                  )}

                  <Grid item md={4} sm={12}>
                    <FormControl required sx={{ width: '15rem' }}>
                      <InputLabel
                        htmlFor="designation-select"
                        style={{ background: '#fff' }}
                      >
                        Designation
                      </InputLabel>
                      <Select
                        sx={{ width: '100%' }}
                        labelId="designation-select"
                        id="designation-select"
                        value={updatedEmployeeDetails?.designation}
                        onChange={handleDesignationChange}
                        displayEmpty
                      >
                        {designationNames?.map((designationName, index) => (
                          <MenuItem key={index} value={designationName}>
                            {designationName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={4} sm={12}>
                    <FormControl required sx={{ width: '15rem' }}>
                      <InputLabel
                        htmlFor="location-select"
                        style={{ background: '#fff' }}
                      >
                        Office Loacation
                      </InputLabel>
                      <Select
                        sx={{ width: '100%' }}
                        labelId="location-select"
                        id="location-select"
                        value={updatedEmployeeDetails?.locationId}
                        onChange={handleLocationChange}
                        displayEmpty
                      >
                        {officeLocation?.map((officeLocation, index) => (
                          <MenuItem key={index} value={officeLocation?.id}>
                            {officeLocation?.locationName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={4} sm={12}>
                    <FormControl sx={{ width: '15rem' }}>
                      <InputLabel
                        id="leave-group-select-label"
                        htmlFor="leave-group-select"
                        style={{ background: '#fff' }}
                        shrink
                      >
                        Leave Group
                      </InputLabel>
                      <Select
                        sx={{ width: '100%' }}
                        labelId="leave-group-select-label"
                        id="leave-group-select"
                        value={updatedEmployeeDetails?.leaveGroupId ?? ''}
                        onChange={handleLeaveGroupChange}
                        displayEmpty
                        label="Leave Group"
                        notched
                      >
                        <MenuItem value="">
                          <em>Clear Leave Group</em>
                        </MenuItem>
                        {leaveGroups
                          ?.filter(
                            (group) =>
                              group?.isActive ||
                              group?.id === updatedEmployeeDetails?.leaveGroupId,
                          )
                          .map((group) => (
                            <MenuItem key={group?.id} value={group?.id}>
                              {group?.groupName}
                              {group?.isActive === false ? ' (inactive)' : ''}
                            </MenuItem>
                          ))}
                      </Select>
                      {leaveGroups?.some(
                        (group) =>
                          group?.id === updatedEmployeeDetails?.leaveGroupId &&
                          group?.isActive === false,
                      ) && (
                        <FormHelperText error>
                          Assigned Leave Group is inactive — quarterly Casual Leave
                          will not grant until reassigned to an active group.
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            </form>
          </FormControl>
        )}
      {!isEditable && (
        <Grid
          sx={{ marginTop: '.4rem' }}
          container
          columns={{ xs: 12 }}
          rowSpacing={2}
          columnSpacing={0}
        >
          <Grid
            item
            md={6}
            sm={12}
            container
            columns={{ xs: 8, md: 9 }}
            columnSpacing={0}
            rowSpacing={4}
          >
            <Grid item md={3} xs={4} className="info-item">
              <Typography>
                <strong>Name</strong>
              </Typography>
              <Typography>
                {userDetails.firstName + ' ' + userDetails.lastName}
              </Typography>
            </Grid>
            <Grid item md={3} xs={4} className="info-item">
              <Typography>
                <strong>Employee ID</strong>
              </Typography>
              <Typography>{userDetails.employeeCode}</Typography>
            </Grid>
            <Grid item md={3} xs={4} className="info-item">
              <Typography>
                <strong>Designation</strong>
              </Typography>
              <Typography>{userDetails.designation}</Typography>
            </Grid>
            <Grid item md={3} xs={4} className="info-item">
              <Typography>
                <strong>Date Of Birth </strong>
              </Typography>
              <Typography>
                {userDetails?.dateOfBirth
                  ? moment(userDetails.dateOfBirth).format('DD/MM/YYYY')
                  : ''}
              </Typography>
            </Grid>
            <Grid item md={3} xs={4} className="info-item">
              <Typography>
                <strong>Gender </strong>
              </Typography>
              <Typography>{userDetails.gender}</Typography>
            </Grid>
            <Grid item md={3} xs={4} className="info-item">
              <Typography>
                <strong>Email Id </strong>
              </Typography>
              <Typography sx={{ wordWrap: 'break-word' }}>
                {userDetails.emailId}
              </Typography>
            </Grid>
            <Grid item md={3} xs={4} className="info-item">
              <Typography>
                <strong>
                  {userDetails?.jobType === 'INTERNSHIP'
                    ? 'Internship Date'
                    : 'Joining Date'}
                </strong>
              </Typography>
              <Typography>
                {userDetails?.jobType === 'INTERNSHIP'
                  ? userDetails?.dateOfInternship
                    ? moment(userDetails.dateOfInternship).format('DD/MM/YYYY')
                    : '-'
                  : userDetails?.dateOfJoining
                    ? moment(userDetails.dateOfJoining).format('DD/MM/YYYY')
                    : '-'}
              </Typography>
            </Grid>
            {userDetails?.reportingManagerDisplayName ? (
              <Grid item md={3} xs={4} className="info-item">
                <Typography>
                  <strong>Reporting Manager</strong>
                </Typography>
                <Typography>
                  {userDetails.reportingManagerDisplayName}
                </Typography>
              </Grid>
            ) : null}
            {userDetails?.careerStartDate ? (
              <Grid item md={3} xs={4} className="info-item">
                <Typography>
                  <strong>Career Start Date</strong>
                </Typography>
                <Typography>
                  {moment(userDetails.careerStartDate).format('DD/MM/YYYY')}
                </Typography>
              </Grid>
            ) : null}
            {userDetails?.internshipEndDate ? (
              <Grid item md={3} xs={4} className="info-item">
                <Typography>
                  <strong>Internship End Date</strong>
                </Typography>
                <Typography>
                  {moment(userDetails.internshipEndDate).format('DD/MM/YYYY')}
                </Typography>
              </Grid>
            ) : null}
            {userOffboardedEndDate?.endDate ? (
              <Grid item md={3} xs={4} className="info-item">
                <Typography>
                  <strong>Date of Leaving</strong>
                </Typography>
                <Typography>
                  {moment(userOffboardedEndDate.endDate).format('DD/MM/YYYY')}
                </Typography>
              </Grid>
            ) : (
              ''
            )}
            <Grid item md={3} xs={4} className="info-item">
              <Typography>
                <strong>Office Location</strong>
              </Typography>
              <Typography>
                {userDetails.locationName ? userDetails.locationName : '-'}
              </Typography>
            </Grid>
            <Grid item md={3} xs={4} className="info-item">
              <Typography>
                <strong>Leave Group</strong>
              </Typography>
              <Typography>
                {userDetails.leaveGroupName ||
                  leaveGroups.find(
                    (group) => group.id === userDetails.leaveGroupId,
                  )?.groupName ||
                  '-'}
              </Typography>
            </Grid>
            <Grid item md={9} xs={8}>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                {KeycloakService.hasRole(['hr']) &&
                location.pathname !== '/user-profile' ? (
                  <Button
                    variant="outlined"
                    color="secondary"
                    style={{ display: 'flex', justifyContent: 'center' }}
                    onClick={() => {
                      navigate(
                        '/user-people/' +
                          userDetails.firstName +
                          ' ' +
                          userDetails.lastName +
                          '/user-timings',
                      );
                      dispatch({
                        type: 'PEOPLE_PAGE',
                        data: {
                          id: people.id,
                          display: false,
                          checked: false,
                        },
                      });
                    }}
                  >
                    Timings
                  </Button>
                ) : (
                  ''
                )}
                {((KeycloakService.hasRole(['manager']) &&
                  isLoggedInUserManager) ||
                  KeycloakService.hasRole(['hr'])) &&
                location.pathname !== '/user-profile' ? (
                  <Button
                    variant="outlined"
                    color="success"
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      marginLeft: '10px',
                      marginRight: '10px',
                    }}
                    onClick={() => {
                      navigate(
                        '/user-people/' +
                          userDetails.firstName +
                          ' ' +
                          userDetails.lastName +
                          '/user-timings',
                      );
                      dispatch({
                        type: 'PEOPLE_PAGE',
                        data: {
                          id: people.id,
                          display: false,
                          checked: true,
                        },
                      });
                    }}
                  >
                    Year view summary
                  </Button>
                ) : (
                  ''
                )}
              </div>
            </Grid>
          </Grid>
          <Grid
            item
            md={2.5}
            container
            columns={{ xs: 4, md: 9 }}
            style={{ paddingTop: '0px' }}
            rowSpacing={2}
          >
            <Grid item md={9} xs={4}>
              <center>
                {currentUserId() === userDetails.id ? (
                  <CardContent sx={{ height: '14rem', borderRadius: '5rem' }}>
                    <div
                      style={{ position: 'relative', display: 'inline-block' }}
                    >
                      <Tooltip
                        title="Edit Photo (PNG file)"
                        placement="bottom"
                        arrow
                      >
                        {uploadedPhoto ? (
                          <>
                            <label htmlFor="photo-upload">
                              <Avatar
                                src={uploadedPhoto}
                                alt="Uploaded Photo"
                                sx={{
                                  width: '11rem',
                                  height: '10rem',
                                  cursor: 'pointer',
                                }}
                              />
                            </label>
                            <Box
                              sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                m: 1,
                              }}
                            >
                              <Button
                                variant="outlined"
                                color={ERROR_KEY}
                                sx={{ m: 1 }}
                                onClick={onCancel}
                              >
                                Cancel
                              </Button>
                              <LoadingButton
                                type="submit"
                                variant="contained"
                                sx={{ m: 1 }}
                                onClick={() => onSave()}
                              >
                                Save
                              </LoadingButton>
                            </Box>
                          </>
                        ) : (
                          <label htmlFor="photo-upload">
                            <Avatar
                              alt="Profile Picture"
                              src={
                                userDetails?.photoPath
                                  ? photoUrl
                                  : '/assets/images/ProfilePicPlaceholder.png'
                              }
                              sx={{
                                width: '11rem',
                                height: '10rem',
                                cursor: 'pointer',
                              }}
                            />
                          </label>
                        )}
                      </Tooltip>
                      <input
                        type="file"
                        accept="image/*"
                        id="photo-upload"
                        style={{ display: 'none' }}
                        onChange={handlePhotoUpload}
                      />
                    </div>
                  </CardContent>
                ) : (
                  <CardContent sx={{ height: '14rem', borderRadius: '5rem' }}>
                    <Avatar
                      alt="Profile Picture"
                      src={
                        userDetails?.photoPath
                          ? photoUrl
                          : '/assets/images/ProfilePicPlaceholder.png'
                      }
                      sx={{ width: '11rem', height: '10rem' }}
                    />
                  </CardContent>
                )}
              </center>
            </Grid>
          </Grid>
        </Grid>
      )}

      <Dialog open={open} fullWidth maxWidth="md" onClose={handleClose}>
        <AddSkill
          handleClose={handleClose}
          editing={editing}
          editSkill={
            approvedSkills?.length > 0 ? approvedSkills[editingIndex] : null
          }
        ></AddSkill>
      </Dialog>
      {!isEditable && (
        <Grid
          sx={{ marginTop: '2rem' }}
          container
          columns={{ xs: 12 }}
          rowSpacing={2}
          columnSpacing={0}
        >
          <Grid
            item
            sm={12}
            container
            columns={{ xs: 4, sm: 8, md: 9 }}
            columnSpacing={0}
            rowSpacing={2}
          >
            <Grid item md={2} xs={4}>
              <CardContent>
                <center>
                  <Typography sx={{ fontWeight: 'medium' }}>
                    Projects
                  </Typography>
                  <hr />
                </center>
                <Scrollbars style={{ height: 145 }}>
                  {userProjects.map((project, index) => (
                    <center key={index}>
                      <Chip sx={{ margin: '4%' }} label={project.projectName} />
                    </center>
                  ))}{' '}
                </Scrollbars>
              </CardContent>
            </Grid>
            <Grid item xs={4}>
              <CardContent>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Typography sx={{ fontWeight: 'medium' }}>Skills</Typography>
                  {location.pathname === '/user-profile' && (
                    <Button
                      sx={{ marginLeft: '1rem' }}
                      variant="outlined"
                      color="primary"
                      size="small"
                      onClick={() => {
                        handleRateYourself();
                      }}
                    >
                      Rate Yourself
                    </Button>
                  )}
                </div>
                <hr className="mt-2" />
                {approvedSkills?.length === 0 ? (
                  <center>
                    <Typography sx={{ color: '#b0b1b3' }}>
                      No approved skills
                    </Typography>
                  </center>
                ) : null}
                {approvedSkills?.map((skill, index) => (
                  <Grid container sx={{ marginTop: '25px' }}>
                    <Grid item xs={4}>
                      <Chip
                        sx={{ marginRight: '12px' }}
                        label={skill.skillName}
                        color="primary"
                      />
                    </Grid>
                    <Grid item xs={5}>
                      <Rating
                        name="read-only"
                        value={
                          skill.approvedRating === 'BEGINNER'
                            ? 1
                            : skill.approvedRating === 'INTERMEDIATE'
                              ? 2
                              : 3
                        }
                        readOnly
                      />
                    </Grid>
                    {location.pathname === '/user-profile' ? (
                      <Grid item xs={2}>
                        <IconButton
                          color="secondary"
                          sx={{ paddingLeft: '0px' }}
                          onClick={() => handleEdit(index)}
                        >
                          <EditIcon />
                        </IconButton>
                      </Grid>
                    ) : null}
                  </Grid>
                ))}
              </CardContent>
            </Grid>
            <Grid item md={3} xs={4} hidden={userLeave == null}>
              <CardContent>
                <center>
                  <Typography sx={{ fontWeight: 'medium' }}>Leaves</Typography>
                </center>
                <hr />
                <center>
                  <Button
                    sx={{
                      width: '70%',
                      marginBottom: '10px',
                      marginTop: '20px',
                    }}
                    variant="outlined"
                    color="error"
                    size="medium"
                    disabled={currentUserId() != userDetails.employeeId}
                    onClick={() => {
                      dispatch({
                        type: 'ACTIVE-TAB',
                      });
                      navigate('/user-leaves', {
                        state: {
                          tabNo: 1,
                          leaveType: userLeave.type,
                          leaveStartDate: userLeave.startDate,
                          leaveEndDate: userLeave.endDate,
                        },
                      });
                    }}
                  >
                    {leaveType(userLeave?.type)}
                    <br />
                    {moment(userLeave?.startDate).format('DD/MM/YYYY')} -{' '}
                    {moment(userLeave?.endDate).format('DD/MM/YYYY')}
                  </Button>
                </center>
              </CardContent>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Card>
  );
};

export default UserProfile;
